module.exports = __webpack_public_path__ + "static/media/8OLA4.f1c26725.jpg";